<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.name') }}</label></td>
      <td>{{ details.name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.role') }}</label></td>
      <td>{{ details.role }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.secret') }}</label></td>
      <td>{{ details.secret }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.cidrs') }}</label></td>
      <td>{{ details.cidrs }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.municipality_id') }}</label></td>
      <td>
        <router-link v-if="details.type === 'municipality'" :to="municipalityLink(details)">
          {{ details.municipality_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('botClients.details.operator_id') }}</label></td>
      <td>
        <router-link v-if="details.type === 'operator'" :to="operatorLink(details)">
          {{ details.operator_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
  </table>
</template>
<script>
import linkUtils from "@/util/link_utils";

export default {
  name: 'bot-client-details',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    municipalityLink(details) {
      return linkUtils.municipalityPath(this.$router, {id: details.municipality_id});
    },
    operatorLink(details) {
      return linkUtils.operatorPath(this.$router, {id: details.operator_id});
    },
  },
  computed: {}
};
</script>
<style></style>
